import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/skill-assessment/icons/timer/clock_loader_90.svg'
import _imports_1 from '@/assets/images/skill-assessment/icons/timer/clock_loader_80.svg'
import _imports_2 from '@/assets/images/skill-assessment/icons/timer/clock_loader_60.svg'
import _imports_3 from '@/assets/images/skill-assessment/icons/timer/clock_loader_40.svg'
import _imports_4 from '@/assets/images/skill-assessment/icons/timer/clock_loader_20.svg'
import _imports_5 from '@/assets/images/skill-assessment/icons/timer/clock_loader_10.svg'


const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = {
  key: 0,
  class: "timer",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "timer",
  src: _imports_1
}
const _hoisted_4 = {
  key: 2,
  class: "timer",
  src: _imports_2
}
const _hoisted_5 = {
  key: 3,
  class: "timer",
  src: _imports_3
}
const _hoisted_6 = {
  key: 4,
  class: "timer",
  src: _imports_4
}
const _hoisted_7 = {
  key: 5,
  class: "timer",
  src: _imports_5
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.timeLeftPrecent >= 90)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : (_ctx.timeLeftPrecent >= 80)
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : (_ctx.timeLeftPrecent >= 60)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_ctx.timeLeftPrecent >= 40)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_ctx.timeLeftPrecent >= 20)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
      _createTextVNode(" Time left: " + _toDisplayString(_ctx.timeLeft), 1)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "mt-0 mb-2" }, null, -1))
  ], 64))
}